module.exports = __webpack_public_path__ + "static/media/person-preparing-get-driver-license.7afeba14.svg";